import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import MaterialPricingLayer from '../components/MaterialPricingLayer';

export default function MaterialPricingPage() {
    return (
        <MasterLayout>
            <Breadcrumb title="Material Pricing" header="O-Ring Material Pricing" />
            <MaterialPricingLayer />
        </MasterLayout>
    );
}
